import React, {useEffect, useMemo, useState} from "react";
import style from "../../../assets/css/profile.module.scss";
import {Box, Grid} from "@mui/system";
import {Avatar, Button, InputLabel, Tooltip} from "@mui/material";
import ColorTheme from "../../../assets/css/_themes-vars.module.scss";
import GlobalTextField from "../../global-fields/GlobalTextField";
import {setUiData} from "../../../store/uiSlice";
import {UPDATE_PROFILE} from "../../../constants/apiConstant";
import GlobalNotificationPopup from "../../global-fields/GlobalNotificationPopup";
import {removeCookies} from "../../../constants/helper";
import {selectAuthState, setAuthData} from "../../../store/authSlice";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {useFormik} from "formik";
import * as yup from "yup";
import GlobalPassword from "../../global-fields/GlobalPassword";
import GlobalSelectField from "../../global-fields/GlobalSelectField";
import {IoIosInformationCircleOutline} from "react-icons/io";
import {State, City} from "country-state-city";
import {styled} from "@mui/material/styles";
import {useCallback} from "react";
import {RxCross2} from "react-icons/rx";
import {IoImagesOutline} from "react-icons/io5";
import {CiEdit} from "react-icons/ci";
import SaveIcon from "@mui/icons-material/Save";
import GlobalPhoneInput from "../../global-fields/GlobalPhoneInput";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

function Profile({
  brokerIsEditor = false,
  clientOfBroker = null,
  fetchDetailsAfterUpdate,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {user} = useSelector(selectAuthState);
  const [statesData, setStatesData] = useState([]);
  const [citiesData, setCitiesData] = useState([]);
  const [enable1Edit, setEnable1Edit] = useState(false);
  const [enable2Edit, setEnable2Edit] = useState(false);
  const [enable3Edit, setEnable3Edit] = useState(false);

  const userData = useMemo(() => {
    return clientOfBroker || user;
  }, [clientOfBroker, user]);
  console.log("userData", userData);
  let initialImgVals = {
    user_id: userData?.id ? userData?.id : 0,
    type: "image",
    preview: null,
    image: null,
  };
  const [imageData, setImageData] = useState(initialImgVals);

  // console.log("USERR", user);
  let initialFormik1Vals = {
    type: "details",
    user_id: userData?.id ? userData?.id : 0,
    first_name: userData?.first_name ? userData?.first_name : "",
    last_name: userData?.last_name ? userData?.last_name : "",
    mobile_no: userData?.mobile_no ? userData?.mobile_no : "",
    email: userData?.email ? userData?.email : "",
    company: userData?.company ? userData?.company : "",
    address1: userData?.address1 ? userData?.address1 : "",
    address2: userData?.address2 ? userData?.address2 : "",
    country: userData?.country ? userData?.country : "",
    state: userData?.state ? userData?.state : "",
    city: userData?.city ? userData?.city : "",
    zipcode: userData?.zipcode ? userData?.zipcode : "",
    image: userData?.image ? userData?.image : null,
    // agent_id: userData?.agent_id ? userData?.agent_id : 0,
    // agent_details: {
    //     agent_id: userData?.agent_details?.agent_id
    //         ? userData?.agent_details?.agent_id
    //         : "",
    //     first_name: userData?.agent_details?.first_name
    //         ? userData?.agent_details?.first_name
    //         : "",
    //     last_name: userData?.agent_details?.last_name
    //         ? userData?.agent_details?.last_name
    //         : "",
    //     mobile_no: userData?.agent_details?.mobile_no
    //         ? userData?.agent_details?.mobile_no
    //         : "",
    //     image: userData?.agent_details?.image ? userData?.agent_details?.image : null,
    //     email: userData?.agent_details?.email ? userData?.agent_details?.email : "",
    // },
  };

  let initialFormik2Vals = {
    type: "cpassword",
    current_password: "",
    new_password: "",
    confirm_new_password: "",
    user_id: userData?.id ? userData?.id : 0,
  };

  let initialFormik3Vals = {
    type: "details",
    user_id: userData?.id ? userData?.id : 0,
    first_name: userData?.first_name ? userData?.first_name : "",
    last_name: userData?.last_name ? userData?.last_name : "",
    mobile_no: userData?.mobile_no ? userData?.mobile_no : "",
    email: userData?.email ? userData?.email : "",
    company: userData?.company ? userData?.company : "",
    address1: userData?.address1 ? userData?.address1 : "",
    address2: userData?.address2 ? userData?.address2 : "",
    country: userData?.country ? userData?.country : "",
    state: userData?.state ? userData?.state : "",
    city: userData?.city ? userData?.city : "",
    zipcode: userData?.zipcode ? userData?.zipcode : "",
    image: userData?.image ? userData?.image : null,
  };

  const handleUpdateProfile = async (e) => {
    dispatch(
      setUiData({
        showLoader: true,
      })
    );
    const formData = new FormData();
    let data = {...e};
    let options = {};
    if (data?.type !== "image") {
      options = {
        method: UPDATE_PROFILE.method,
        headers: UPDATE_PROFILE.headers,
        body: JSON.stringify(data),
      };
    } else {
      formData.append("user_id", data?.user_id);
      formData.append("type", data?.type);
      formData.append("image", data?.image, "user_image");
      options = {
        method: UPDATE_PROFILE.method,
        body: formData,
      };
    }
    fetch(UPDATE_PROFILE.url, options)
      .then((response) => response.json())
      .then((res) => {
        if (res.status == 0) {
          dispatch(
            setUiData({
              showLoader: false,
            })
          );
          GlobalNotificationPopup({type: "error", message: res?.message});
          removeCookies("isLogin");
        } else if (res.status == 1) {
          GlobalNotificationPopup({type: "success", message: res?.message});
          if (brokerIsEditor) {
            fetchDetailsAfterUpdate();
          } else {
            dispatch(
              setAuthData({
                user_id: res?.user_id,
                user: res?.user,
              })
            );
          }
          dispatch(
            setUiData({
              showLoader: false,
            })
          );
          setEnable1Edit(false);
          setEnable2Edit(false);
          setEnable3Edit(false);
        }
      })
      .catch((error) => {
        removeCookies("isLogin");
        GlobalNotificationPopup({type: "error", message: error});
        console.log("error", error);
        dispatch(
          setUiData({
            showLoader: false,
          })
        );
        navigate("/");
        formik1.resetForm();
        formik2.resetForm();
        formik3.resetForm();
      });
  };

  const formik1 = useFormik({
    initialValues: initialFormik1Vals,
    onSubmit: (values) => {
      handleUpdateProfile(values);
    },
    validationSchema: yup.object().shape({
      first_name: yup
        .string()
        .trim()
        .required("First Name is required!")
        .min(2, "First Name must be at least 2 characters."),
      last_name: yup
        .string()
        .trim()
        .required("Last Name is required!")
        .min(2, "Last Name must be at least 2 characters."),
      mobile_no: yup
        .string()
        .required("Mobile Number is required!")
        .matches(/^[+()\-.\s\d]+$/, "Enter a valid mobile number."),
      email: yup
        .string()
        .email("Enter a valid email address!")
        .required("Email is required!"),
    }),
  });

  const formik2 = useFormik({
    initialValues: initialFormik2Vals,
    onSubmit: (values) => {
      delete values.confirm_new_password;
      handleUpdateProfile(values);
    },
    validationSchema: yup.object().shape({
      current_password: yup
        .string()
        .trim()
        .required("Current Password is required!"),
      new_password: yup
        .string()
        .trim()
        .required("New Password is required!")
        .matches(
          /^(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*])(?=.*\d).{8,}$/,
          "New Password must be at least 8 characters long, include 1 uppercase letter, 1 lowercase letter, 1 special character, and 1 number."
        ),
      confirm_new_password: yup
        .string()
        .trim()
        .required("Confirm New Password is required!")
        .oneOf([yup.ref("new_password"), null], "New Passwords must match."),
    }),
  });

  const formik3 = useFormik({
    initialValues: initialFormik3Vals,
    onSubmit: (values) => {
      handleUpdateProfile(values);
    },
    validationSchema: yup.object().shape({
      company: yup.string().trim().required("Company Name is required!"),
      address1: yup
        .string()
        .trim()
        .required("Company Address Line 1 is required!"),
      address2: yup.string().trim().notRequired(),
      state: yup.string().required("State is required!"),
      // .oneOf(usStates, "Enter a valid US state."),
      city: yup
        .string()
        .trim()
        .required("City is required!")
        .test(
          "city-requires-state",
          "Please select a state before selecting a city!",
          function (value) {
            // Access the `state` value using `this.parent`
            const state = this.parent.state;
            return Boolean(state); // Return true only if state is selected
          }
        ),
      zipcode: yup
        .string()
        .required("Zip Code is required!")
        .matches(
          /^\d{5}(-\d{4})?$/,
          "Enter a valid US zip code (e.g., 12345 or 12345-6789)."
        ),
    }),
  });

  useEffect(() => {
    if (State) {
      let countryCode = "US";
      let allStates = State.getStatesOfCountry(countryCode);
      setStatesData(allStates);
    }
  }, [State]);

  const statesArr = useMemo(() => statesData, [statesData]);

  const makeCityData = (e) => {
    let filteredCity = statesArr.find((item) => item.name === e);

    let c = City.getCitiesOfState(
      filteredCity?.countryCode,
      filteredCity?.isoCode
    );
    setCitiesData(c);
  };

  useEffect(() => {
    if (userData?.state && userData?.city && statesArr) {
      makeCityData(userData?.state);
    }
  }, [user, statesArr]);

  const citiesArr = useMemo(() => citiesData, [citiesData]);

  const handleImgChange = (e) => {
    if (e.target.files.length) {
      setImageData({
        ...imageData,
        preview: URL.createObjectURL(e.target.files[0]),
        image: e.target.files[0],
      });
    }
  };

  const updateProfilePic = useCallback(() => {
    handleUpdateProfile(imageData);
  }, [imageData]);

  return (
    <>
      <section className={style.profileSection}>
        <Grid container spacing={2} className="customeContainer">
          {brokerIsEditor ? null : (
            <Grid size={{xs: 12, lg: 4}} className="profileAct">
              <div className={style.profileDetailsMain}>
                <div className={style.dashboardProfileAvtar}>
                  <div className={style.editImg}>
                    <Avatar
                      sx={{
                        mr: 3,
                        width: 150,
                        height: 150,
                        bgcolor: "#fff",
                        fontSize: "50px",
                        background: "#fff",
                        color: "#cdcdcd",
                        margin: "auto",
                      }}
                      src={
                        imageData?.preview
                          ? imageData?.preview
                          : userData?.image
                            ? userData?.image
                            : ""
                      }
                      aria-label="avtar-img"
                      variant="circle"
                    >
                      {!userData?.image
                        ? userData?.first_name?.charAt(0)?.toUpperCase() +
                          userData?.last_name?.charAt(0)?.toUpperCase()
                        : null}
                    </Avatar>
                    <Button
                      component="label"
                      role={undefined}
                      variant="outlined"
                      aria-label="icon"
                    >
                      <IoImagesOutline />
                      <VisuallyHiddenInput
                        type="file"
                        accept="image/*"
                        onChange={handleImgChange}
                      />
                    </Button>
                  </div>

                  <div className={style.profileDetailsText}>
                    <h3>
                      {userData?.first_name} {userData?.last_name}
                    </h3>
                    <p>{userData?.email}</p>
                  </div>

                  <div className={style.profileDetailsBtn}>
                    <Button
                      disabled={imageData?.image === null}
                      sx={{background: ColorTheme?.SuryaPrimary, color: "#fff"}}
                      type="button"
                      onClick={updateProfilePic}
                    >
                      Save Image
                    </Button>
                  </div>
                </div>

                {userData?.user_type !== "agent" ? (
                  <Box className={style.agentDetails}>
                    <div className={style.dashboardProfileAvtar}>
                      <div className={style.BadgeAgent}>
                        <span> Agent Details </span>
                      </div>
                      {/* <h3> Agent Details </h3> */}
                      <Avatar
                        sx={{
                          mt: 2,
                          mr: 3,
                          width: 150,
                          height: 150,
                          bgcolor: "#fff",
                          fontSize: "50px",
                          background: "#fff",
                          color: "#cdcdcd",
                          margin: "auto",
                        }}
                        src={
                          userData?.agent_details?.image
                            ? userData?.agent_details?.image
                            : ""
                        }
                        variant="circle"
                      >
                        {userData?.agent_details?.agent_id ? "" : "!"}
                      </Avatar>
                      <div>
                        {userData?.agent_details?.agent_id ? (
                          <>
                            <h3>
                              {`${
                                userData?.agent_details?.first_name
                                  ? userData?.agent_details?.first_name
                                  : null
                              } ${
                                userData?.agent_details?.last_name
                                  ? userData?.agent_details?.last_name
                                  : null
                              }`}
                            </h3>
                            <p>
                              {userData?.agent_details?.email
                                ? userData?.agent_details?.email
                                : null}
                            </p>
                            <p>
                              {userData?.agent_details?.mobile_no
                                ? userData?.agent_details?.mobile_no
                                : null}
                            </p>
                          </>
                        ) : (
                          <span className={style.noAgent}>
                            NO AGENT ASSIGNED
                          </span>
                        )}
                      </div>
                    </div>
                  </Box>
                ) : null}
              </div>
            </Grid>
          )}
          <Grid
            size={{xs: 12, lg: brokerIsEditor ? 12 : 8}}
            className="profileAct"
          >
            <form
              autoComplete="false"
              autoSave="false"
              onSubmit={formik1.handleSubmit}
            >
              <div className={style.myAccountDetails}>
                <div className={style.myAccount}>
                  <h2>Personal Details </h2>
                  <div className={style.myAccountEditBtn}>
                    {enable1Edit ? (
                      <>
                        <Button
                          aria-label="edit_btn"
                          type="button"
                          variant="outlined"
                          onClick={() => {
                            formik1.resetForm();
                            setEnable1Edit(!enable1Edit);
                          }}
                        >
                          {/* CANCEL */}
                          <RxCross2 />
                        </Button>
                        <Button
                          disabled={!formik1.dirty || !enable1Edit}
                          type="submit"
                          aria-label="save_btn"
                        >
                          {/* UPDATE */}
                          <SaveIcon />
                        </Button>
                      </>
                    ) : (
                      <Button
                        aria-label="edit_btn"
                        type="button"
                        variant="outlined"
                        onClick={() => setEnable1Edit(!enable1Edit)}
                      >
                        {/* EDIT */}
                        <CiEdit />
                      </Button>
                    )}
                  </div>
                </div>

                <Grid
                  container
                  spacing={2}
                  className={style.ProfileformField + " " + "Profileform"}
                >
                  <Grid size={{xs: 12, lg: 6}}>
                    <InputLabel
                      sx={{mb: 1}}
                      htmlFor="my-input"
                      style={{color: "black"}}
                    >
                      First Name
                    </InputLabel>

                    {/* This label is provided only to fix the ADA error, not to display it on the screen. */}
                    <label
                      style={{
                        opacity: "0",
                        position: "absolute",
                        zIndex: "-99px",
                        top: "0",
                        left: "0",
                      }}
                      htmlFor="first_name"
                    >
                      first_name
                    </label>

                    <GlobalTextField
                      id="first_name"
                      name="first_name"
                      type="text"
                      value={formik1.values.first_name}
                      onChange={(e) =>
                        formik1.setFieldValue("first_name", e.target.value)
                      }
                      onBlur={formik1.handleBlur}
                      error={
                        formik1.touched.first_name &&
                        Boolean(formik1.errors.first_name)
                      }
                      helperText={
                        formik1.touched.first_name && formik1.errors.first_name
                      }
                      cssClass={
                        !enable1Edit ? style.editInput : style.defaultInput
                      }
                      disabled={!enable1Edit}
                    />
                  </Grid>

                  <Grid size={{xs: 12, lg: 6}}>
                    <InputLabel
                      sx={{mb: 1}}
                      htmlFor="my-input"
                      style={{color: "black"}}
                    >
                      Last Name
                    </InputLabel>

                    {/* This label is provided only to fix the ADA error, not to display it on the screen. */}
                    <label
                      style={{
                        opacity: "0",
                        position: "absolute",
                        zIndex: "-99px",
                        top: "0",
                        left: "0",
                      }}
                      htmlFor="last_name"
                    >
                      last_name
                    </label>
                    <GlobalTextField
                      id="last_name"
                      name="last_name"
                      type="text"
                      value={formik1.values.last_name}
                      onChange={(e) =>
                        formik1.setFieldValue("last_name", e.target.value)
                      }
                      onBlur={formik1.handleBlur}
                      error={
                        formik1.touched.last_name &&
                        Boolean(formik1.errors.last_name)
                      }
                      helperText={
                        formik1.touched.last_name && formik1.errors.last_name
                      }
                      cssClass={
                        !enable1Edit ? style.editInput : style.defaultInput
                      }
                      disabled={!enable1Edit}
                    />
                  </Grid>

                  <Grid size={{xs: 12, lg: 6}}>
                    <InputLabel
                      sx={{mb: 1}}
                      htmlFor="my-input"
                      style={{color: "black"}}
                    >
                      Mobile Number
                    </InputLabel>
                    <GlobalPhoneInput
                      id="mobile_no"
                      name="mobile_no"
                      value={formik1.values.mobile_no}
                      onChange={({value, countryDetails, formattedVal}) => {
                        //const value = e.target.value.replace(/[^0-9]/g, "");
                        formik1.setFieldValue("mobile_no", formattedVal);
                      }}
                      onBlur={formik1.handleBlur}
                      error={
                        formik1.touched.mobile_no &&
                        Boolean(formik1.errors.mobile_no)
                      }
                      helperText={
                        formik1.touched.mobile_no && formik1.errors.mobile_no
                      }
                      cssClass={!enable1Edit ? "phoneinputDiabledClass" : ""}
                      disabled={!enable1Edit}
                    />
                  </Grid>

                  <Grid size={{xs: 12, lg: 6}}>
                    <InputLabel
                      sx={{mb: 1}}
                      htmlFor="my-input"
                      style={{color: "black"}}
                    >
                      Email Address
                    </InputLabel>

                    {/* This label is provided only to fix the ADA error, not to display it on the screen. */}
                    <label
                      style={{
                        opacity: "0",
                        position: "absolute",
                        zIndex: "-99px",
                        top: "0",
                        left: "0",
                      }}
                      htmlFor="email"
                    >
                      email
                    </label>

                    <GlobalTextField
                      id="email"
                      name="email"
                      type="email"
                      value={formik1.values.email}
                      onChange={formik1.handleChange}
                      onBlur={formik1.handleBlur}
                      error={
                        formik1.touched.email && Boolean(formik1.errors.email)
                      }
                      helperText={formik1.touched.email && formik1.errors.email}
                      cssClass={
                        !enable1Edit ? style.editInput : style.defaultInput
                      }
                      disabled={!enable1Edit}
                    />
                  </Grid>
                </Grid>
              </div>
            </form>

            <form
              autoComplete="false"
              autoSave="false"
              onSubmit={formik3.handleSubmit}
            >
              <div className={style.myAccountDetails}>
                <div className={style.myAccount}>
                  <h2>Company Details </h2>
                  <div className={style.myAccountEditBtn}>
                    {enable3Edit ? (
                      <>
                        <Button
                          aria-label="edit_btn"
                          type="button"
                          variant="outlined"
                          onClick={() => {
                            formik3.resetForm();
                            setEnable3Edit(!enable3Edit);
                          }}
                        >
                          {/* CANCEL */}
                          <RxCross2 />
                        </Button>
                        <Button
                          aria-label="save_btn"
                          disabled={!formik3.dirty || !enable3Edit}
                          type="submit"
                        >
                          {/* UPDATE */}
                          <SaveIcon />
                        </Button>
                      </>
                    ) : (
                      <Button
                        aria-label="edit_btn"
                        type="button"
                        variant="outlined"
                        onClick={() => setEnable3Edit(!enable3Edit)}
                      >
                        {/* EDIT */}
                        <CiEdit />
                      </Button>
                    )}
                  </div>
                </div>
                <Grid
                  container
                  spacing={2}
                  className={style.ProfileformField + " " + "Profileform"}
                >
                  <Grid size={{xs: 12, lg: 12}}>
                    <InputLabel
                      sx={{mb: 1}}
                      htmlFor="my-input"
                      style={{color: "black"}}
                    >
                      Company Name
                    </InputLabel>
                    {/* This label is provided only to fix the ADA error, not to display it on the screen. */}
                    <label
                      style={{
                        opacity: "0",
                        position: "absolute",
                        zIndex: "-99px",
                        top: "0",
                        left: "0",
                      }}
                      htmlFor="company"
                    >
                      company
                    </label>

                    <GlobalTextField
                      id="company"
                      name="company"
                      type="text"
                      value={formik3.values.company}
                      onChange={(e) =>
                        formik3.setFieldValue("company", e.target.value)
                      }
                      onBlur={formik3.handleBlur}
                      error={
                        formik3.touched.company &&
                        Boolean(formik3.errors.company)
                      }
                      helperText={
                        formik3.touched.company && formik3.errors.company
                      }
                      cssClass={
                        !enable3Edit ? style.editInput : style.defaultInput
                      }
                      disabled={!enable3Edit}
                    />
                  </Grid>
                  <Grid size={{xs: 12, lg: 6}}>
                    <InputLabel
                      sx={{mb: 1}}
                      htmlFor="my-input"
                      style={{color: "black"}}
                    >
                      Company Address Line 1
                    </InputLabel>
                    {/* This label is provided only to fix the ADA error, not to display it on the screen. */}
                    <label
                      style={{
                        opacity: "0",
                        position: "absolute",
                        zIndex: "-99px",
                        top: "0",
                        left: "0",
                      }}
                      htmlFor="address1"
                    >
                      address1
                    </label>

                    <GlobalTextField
                      id="address1"
                      name="address1"
                      type="text"
                      value={formik3.values.address1}
                      onChange={(e) =>
                        formik3.setFieldValue("address1", e.target.value)
                      }
                      onBlur={formik3.handleBlur}
                      error={
                        formik3.touched.address1 &&
                        Boolean(formik3.errors.address1)
                      }
                      helperText={
                        formik3.touched.address1 && formik3.errors.address1
                      }
                      cssClass={
                        !enable3Edit ? style.editInput : style.defaultInput
                      }
                      disabled={!enable3Edit}
                    />
                  </Grid>

                  <Grid size={{xs: 12, lg: 6}}>
                    <InputLabel
                      sx={{mb: 1}}
                      htmlFor="my-input"
                      style={{color: "black"}}
                    >
                      Company Address Line 2
                    </InputLabel>

                    {/* This label is provided only to fix the ADA error, not to display it on the screen. */}
                    <label
                      style={{
                        opacity: "0",
                        position: "absolute",
                        zIndex: "-99px",
                        top: "0",
                        left: "0",
                      }}
                      htmlFor="address2"
                    >
                      address2
                    </label>

                    <GlobalTextField
                      id="address2"
                      name="address2"
                      type="text"
                      value={formik3.values.address2}
                      onChange={(e) =>
                        formik3.setFieldValue("address2", e.target.value)
                      }
                      onBlur={formik3.handleBlur}
                      error={
                        formik3.touched.address2 &&
                        Boolean(formik3.errors.address2)
                      }
                      helperText={
                        formik3.touched.address2 && formik3.errors.address2
                      }
                      cssClass={
                        !enable3Edit ? style.editInput : style.defaultInput
                      }
                      disabled={!enable3Edit}
                    />
                  </Grid>

                  <Grid size={{xs: 12, lg: 6}}>
                    <InputLabel
                      sx={{mb: 1}}
                      htmlFor="my-input"
                      style={{color: "black"}}
                    >
                      State
                    </InputLabel>

                    <GlobalSelectField
                      id="state"
                      name="state"
                      labelId="state-select"
                      value={formik3.values.state}
                      onChange={(e) => {
                        setCitiesData([]);
                        formik3.setFieldValue("state", e.target?.value);
                        makeCityData(e.target.value);
                      }}
                      onBlur={formik3.handleBlur}
                      error={
                        formik3.touched.state && Boolean(formik3.errors.state)
                      }
                      helperText={formik3.touched.state && formik3.errors.state}
                      menuItems={statesArr}
                      isStateOrCity
                      cssClass={
                        !enable3Edit ? style.editInput : style.defaultInput
                      }
                      disabled={!enable3Edit}
                    />
                  </Grid>
                  <Grid size={{xs: 12, lg: 6}}>
                    <InputLabel
                      sx={{mb: 1}}
                      htmlFor="my-input"
                      style={{color: "black"}}
                    >
                      City
                    </InputLabel>
                    <GlobalSelectField
                      id="cit"
                      name="cit"
                      labelId="city-select"
                      value={formik3.values.city}
                      onChange={(e) => {
                        if (!formik3.values.state) {
                          GlobalNotificationPopup({
                            type: "warning",
                            message: "Please select a State first!",
                          });
                          return;
                        }
                        if (citiesArr.length === 0) {
                          GlobalNotificationPopup({
                            type: "error",
                            message:
                              "No cities available for the selected state!",
                          });
                          return;
                        }
                        formik3.setFieldValue("city", e.target.value);
                      }}
                      onBlur={formik3.handleBlur}
                      error={
                        formik3.touched.city && Boolean(formik3.errors.city)
                      }
                      helperText={formik3.touched.city && formik3.errors.city}
                      menuItems={
                        citiesArr.length > 0
                          ? citiesArr
                          : [{name: "Select State First!", value: ""}]
                      }
                      isStateOrCity
                      disabled={!enable3Edit || formik3.values.state === ""}
                      cssClass={
                        !enable3Edit ? style.editInput : style.defaultInput
                      }
                    />
                  </Grid>
                  <Grid size={{xs: 12, lg: 6}}>
                    <InputLabel
                      sx={{mb: 1}}
                      htmlFor="my-input"
                      style={{color: "black"}}
                    >
                      Zip
                    </InputLabel>

                    {/* This label is provided only to fix the ADA error, not to display it on the screen. */}
                    <label
                      style={{
                        opacity: "0",
                        position: "absolute",
                        zIndex: "-99px",
                        top: "0",
                        left: "0",
                      }}
                      htmlFor="zipcode"
                    >
                      zipcode
                    </label>

                    <GlobalTextField
                      id="zipcode"
                      name="zipcode"
                      type="text"
                      value={formik3.values.zipcode}
                      onChange={(e) =>
                        formik3.setFieldValue("zipcode", e.target.value)
                      }
                      onBlur={formik3.handleBlur}
                      error={
                        formik3.touched.zipcode &&
                        Boolean(formik3.errors.zipcode)
                      }
                      helperText={
                        formik3.touched.zipcode && formik3.errors.zipcode
                      }
                      cssClass={
                        !enable3Edit ? style.editInput : style.defaultInput
                      }
                      disabled={!enable3Edit}
                    />
                  </Grid>
                  <Grid size={{xs: 12, lg: 6}}>
                    <InputLabel
                      sx={{mb: 1}}
                      htmlFor="my-input"
                      style={{color: "black", pointerEvents: "none !important"}}
                    >
                      Country
                      <Tooltip
                        arrow
                        placement="right"
                        title="Default Country - United States, Can’t be changed."
                      >
                        <IoIosInformationCircleOutline
                          style={{marginLeft: "5px"}}
                        />
                      </Tooltip>
                    </InputLabel>

                    <GlobalTextField
                      id="count"
                      name="count"
                      type="text"
                      value={"United States"}
                      cssClass={
                        !enable3Edit ? style.editInput : style.defaultInput
                      }
                      style={{pointerEvents: "none !important"}}
                      disabled
                    />
                  </Grid>
                </Grid>
              </div>
            </form>
            {brokerIsEditor ? null : (
              <form
                autoComplete="false"
                autoSave="false"
                onSubmit={formik2.handleSubmit}
              >
                <div className={style.myAccountDetails}>
                  <div className={style.myAccount}>
                    <h2>Security </h2>
                    <div className={style.myAccountEditBtn}>
                      {enable2Edit ? (
                        <>
                          <Button
                            aria-label="edit_btn"
                            type="button"
                            variant="outlined"
                            onClick={() => {
                              formik2.resetForm();
                              setEnable2Edit(!enable2Edit);
                            }}
                          >
                            {/* CANCEL */}
                            <RxCross2 />
                          </Button>
                          <Button
                            aria-label="save_btn"
                            disabled={!formik2.dirty || !enable2Edit}
                            type="submit"
                          >
                            {/* UPDATE */}
                            <SaveIcon />
                          </Button>
                        </>
                      ) : (
                        <Button
                          aria-label="edit_btn"
                          type="button"
                          variant="outlined"
                          onClick={() => setEnable2Edit(!enable2Edit)}
                        >
                          {/* EDIT */}
                          <CiEdit />
                        </Button>
                      )}
                    </div>
                  </div>
                  <Grid
                    container
                    spacing={2}
                    className={style.ProfileformField + " " + "Profileform11"}
                  >
                    <Grid size={{xs: 12, lg: 4}}>
                      <div className={style.logPassField}>
                        <InputLabel
                          sx={{mb: 1}}
                          htmlFor="outlined-adornment-password"
                          style={{
                            color: "black",
                            opacity: !enable2Edit ? 0.5 : 1,
                          }}
                        >
                          Current Password
                        </InputLabel>

                        {/* This label is provided only to fix the ADA error, not to display it on the screen. */}
                        <label
                          style={{
                            opacity: "0",
                            position: "absolute",
                            zIndex: "-99px",
                            top: "0",
                            left: "0",
                          }}
                          htmlFor="current_password"
                        >
                          current_password
                        </label>

                        <GlobalPassword
                          id="current_password"
                          name="current_password"
                          placeH="********"
                          type="password"
                          label="current_password"
                          value={formik2.values.current_password}
                          onChange={(e) =>
                            formik2.setFieldValue(
                              "current_password",
                              e.target.value
                            )
                          }
                          onBlur={formik2.handleBlur}
                          error={
                            formik2.touched.current_password &&
                            Boolean(formik2.errors.current_password)
                          }
                          helperText={
                            formik2.touched.current_password &&
                            formik2.errors.current_password
                          }
                          cssClass={
                            !enable2Edit
                              ? style.editPasswordInput
                              : style.defaultPasswordInput
                          }
                          disabled={!enable2Edit}
                          // showPass={enable2Edit}
                        />
                      </div>
                    </Grid>
                    <Grid size={{xs: 12, lg: 4}}>
                      <div className={style.logPassField}>
                        <InputLabel
                          sx={{mb: 1}}
                          htmlFor="outlined-adornment-password"
                          style={{
                            color: "black",
                            opacity: !enable2Edit ? 0.5 : 1,
                          }}
                        >
                          New Password
                        </InputLabel>

                        {/* This label is provided only to fix the ADA error, not to display it on the screen. */}
                        <label
                          style={{
                            opacity: "0",
                            position: "absolute",
                            zIndex: "-99px",
                            top: "0",
                            left: "0",
                          }}
                          htmlFor="new_password"
                        >
                          new_password
                        </label>

                        <GlobalPassword
                          id="new_password"
                          name="new_password"
                          placeH="********"
                          type="password"
                          label="new_password"
                          value={formik2.values.new_password}
                          onChange={(e) =>
                            formik2.setFieldValue(
                              "new_password",
                              e.target.value
                            )
                          }
                          onBlur={formik2.handleBlur}
                          error={
                            formik2.touched.new_password &&
                            Boolean(formik2.errors.new_password)
                          }
                          helperText={
                            formik2.touched.new_password &&
                            formik2.errors.new_password
                          }
                          cssClass={
                            !enable2Edit
                              ? style.editPasswordInput
                              : style.defaultPasswordInput
                          }
                          disabled={!enable2Edit}
                        />
                      </div>
                    </Grid>
                    <Grid size={{xs: 12, lg: 4}}>
                      {/* {enable2Edit ? ( */}
                      <div className={style.logPassField}>
                        <InputLabel
                          sx={{mb: 1}}
                          htmlFor="outlined-adornment-confirm-password"
                          style={{
                            color: "black",
                            opacity: !enable2Edit ? 0.5 : 1,
                          }}
                        >
                          Confirm New Password
                        </InputLabel>

                        {/* This label is provided only to fix the ADA error, not to display it on the screen. */}
                        <label
                          style={{
                            opacity: "0",
                            position: "absolute",
                            zIndex: "-99px",
                            top: "0",
                            left: "0",
                          }}
                          htmlFor="confirm_new_password"
                        >
                          confirm_new_password
                        </label>

                        <GlobalPassword
                          id="confirm_new_password"
                          name="confirm_new_password"
                          type="password"
                          placeH="********"
                          label="confirm_new_password"
                          value={formik2.values.confirm_new_password}
                          onChange={(e) =>
                            formik2.setFieldValue(
                              "confirm_new_password",
                              e.target.value
                            )
                          }
                          onBlur={formik2.handleBlur}
                          error={
                            formik2.touched.confirm_new_password &&
                            Boolean(formik2.errors.confirm_new_password)
                          }
                          helperText={
                            formik2.touched.confirm_new_password &&
                            formik2.errors.confirm_new_password
                          }
                          cssClass={
                            !enable2Edit
                              ? style.editPasswordInput
                              : style.defaultPasswordInput
                          }
                          disabled={!enable2Edit}
                        />
                      </div>
                      {/* ) : null} */}
                    </Grid>
                  </Grid>
                </div>
              </form>
            )}
          </Grid>
        </Grid>
      </section>
    </>
  );
}

export default Profile;
